module.exports = __webpack_public_path__ + "static/img/bg-overview@w.ad6bd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/bg-overview@w.jpg
// module id = IHXw
// module chunks = 0